import * as Yup from "yup";

export const kursusDeltagereCancelFormConfig = (
  kursusId: string,
  kursusPersonId: string,
): FormConfig<CancelKursusPersonDTO> => {
  const get = `kursus/${kursusId}/deltagere/${kursusPersonId}`;
  const query = `kursus/${kursusId}/wizards/afmeldkursusperson/${kursusPersonId}`;
  return {
    get,
    title: "deltager",
    lockedValues: [
      {
        id: "kursusId",
        value: kursusId,
      },
      {
        id: "kursusPersonId",
        value: kursusPersonId,
      },
    ],
    form: [
      {
        component: "textinput",
        id: "afmeldingsGebyr",
        initialValue: "",
        label: "Afmeldingsgebyr",
        placeholder: "0",
        isRequired: true,
      },
    ],
    validationSchema: Yup.object({
      afmeldingsGebyr: Yup.number().required("Afmeldingsgebyr skal være valgt"),
    }),
    post: (body) => {
      return {
        body,
        query,
      };
    },
  };
};
